import React, { useEffect } from 'react';

import { useForm } from 'react-hook-form';

import { useDispatch } from 'react-redux';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

// Material components
import { Button, Grid2, TextField } from '@mui/material';

import * as action from 'js/actions/userActions';
import { showRoles } from 'js/actions/roleActions';

// Component styles
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
const useStyles = makeStyles(styles);

export default function FormUserEditable() {
  const intl = useIntl();
  const classes = useStyles();
  const { handleSubmit, register } = useForm();
  const dispatch = useDispatch();
  const { user } = useParams();

  useEffect(() => {
    dispatch(showRoles());
  }, []);

  const onSubmit = (user) => {
    dispatch(action.updateAccount(user));
  };

  return (
    <DashboardLayout
      title={intl.formatMessage({ id: 'app.myaccount.editUser.head' })}
    >
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel
              title={intl.formatMessage({ id: 'app.myaccount.editUser.title' })}
            />
          </PortletHeader>
          <PortletContent noPadding>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container spacing={4}>
                <Grid2 item lg={6} md={6} xl={6} xs={6}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      defaultValue={user.personal_info.firstname}
                      {...register('firstname')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.firstNameLabel',
                      })}
                      name="firstname"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.personal_info.lastname}
                      {...register('lastname')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.lastNameLabel',
                      })}
                      name="lastname"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.personal_info.email}
                      {...register('email')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.emailLabel',
                      })}
                      name="email"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      helperText={intl.formatMessage({
                        id: 'app.myaccount.editUser.passwordRules',
                      })}
                      {...register('password')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.newPasswordLabel',
                      })}
                      name="password"
                      type="password"
                      variant="filled"
                    />
                  </div>
                </Grid2>
                <Grid2 item lg={3} md={3} xl={3} xs={3}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      defaultValue={user.personal_info.tel}
                      {...register('tel')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.phoneNumbLabel',
                      })}
                      name="tel"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.personal_info.cel}
                      {...register('cel')}
                      label={intl.formatMessage({
                        id: 'app.myaccount.editUser.cellPhoneLabel',
                      })}
                      name="cel"
                      variant="filled"
                    />
                    {/*  */}
                  </div>
                </Grid2>
              </Grid2>
              <Button
                className={classes.signUpButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
              >
                {intl.formatMessage({ id: 'app.myaccount.editUser.updateBtn' })}
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
